import Auth0Lock from 'auth0-lock'

import ApolloClient from './apollo';

import {
  APP_ROOT,
  AUTH0_CLIENT_ID,
  AUTH0_DOMAIN,
  AUTH0_ID_TOKEN_NAME
} from './consts';

import UserQuery from './graphql/queries/user.graphql';
import CreateUserMutation from './graphql/mutations/create-user.graphql';
import UpdateUserMutation from './graphql/mutations/update-user.graphql';


const Lock = new Auth0Lock(AUTH0_CLIENT_ID, AUTH0_DOMAIN);
Lock.on('authenticated', onAuthenticated);


function onAuthenticated(response) {
  const { accessToken, idToken } = response;

  localStorage.setItem(AUTH0_ID_TOKEN_NAME, idToken);

  Promise
    .all([
      getUser(),
      getAuth0UserInfo(accessToken)
    ])
    .then(([user, auth0User]) => updateUserWithAuth0Info(user, auth0User));
}

function getAuth0UserInfo(accessToken) {
  return new Promise((resolve, reject) => {
    Lock.getUserInfo(accessToken, (err, response) => {
      if (err) {
        reject(err);
      }
      resolve(response);
    });
  });
}

function getUser() {
  return new Promise((resolve, reject) => {
    const queryOptions = {
      query: UserQuery,
      fetchPolicy: 'network-only'
    };

    ApolloClient
      .query(queryOptions)
      .then(({ data: { user }}) => {
        if (user) {
          resolve(user);
        } else {
          createUser().then(resolve, reject);
        }
      });
  });
}

function createUser() {
  const idToken = localStorage.getItem(AUTH0_ID_TOKEN_NAME);
  const mutationOptions = {
    mutation: CreateUserMutation,
    variables: {
      idToken
    }
  };

  return ApolloClient
    .mutate(mutationOptions)
    .then(({ data: { createUser }}) => {
      return createUser;
    });
}

function updateUserWithAuth0Info(user, auth0User) {
  const mutationOptions = {
    mutation: UpdateUserMutation,
    variables: {
      id: user.id,
      avatarUrl: auth0User.picture,
      emailAddress: auth0User.email,
      name: auth0User.name
    }
  };

  window.location = `${APP_ROOT}/signup`;

  return ApolloClient
    .mutate(mutationOptions)
    .then(({ data: { updateUser }}) => {
      return updateUser;
    });
}

function logout() {
  localStorage.clear();
  window.location.reload();
}

function showAuth0Lock() {
  Lock.show();
}

export {
  logout,
  showAuth0Lock
}



// WEBPACK FOOTER //
// ./src/auth.js